var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVApps02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3068_81531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7614 17.9586H36.6837C37.4792 17.9586 38.1241 18.6035 38.1241 19.399V43.8858C38.1241 44.6813 37.4792 45.3262 36.6837 45.3262H9.31617C8.52069 45.3262 7.87579 44.6813 7.87579 43.8858V19.399C7.87579 18.6035 8.52069 17.9586 9.31617 17.9586H17.2383",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6788 20.8394H27.3212",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87579 23.7202H38.1242",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5052 20.8403C20.2597 20.4164 20.1192 19.924 20.1192 19.3989C20.1192 17.8078 21.4089 16.5181 23 16.5181C24.591 16.5181 25.8808 17.8078 25.8808 19.3989C25.8808 19.9237 25.7405 20.4156 25.4953 20.8394",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0414 3.55455C28.0414 5.1456 26.7517 6.4353 25.1606 6.4353C23.5696 6.4353 22.2798 5.1456 22.2798 3.55455C22.2798 1.9636 23.5696 0.673803 25.1606 0.673803C26.7517 0.673803 28.0414 1.9636 28.0414 3.55455Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6837 39.5645H38.1242",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87579 39.5645H33.8029",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9586 42.4453H35.2434",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7566 42.4453H15.0776",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0777 41.7252V43.1655",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7584 32.644L21.7399 35.1533C20.9953 35.5256 20.1192 34.9842 20.1192 34.1517V29.1331C20.1192 28.3007 20.9953 27.7592 21.7399 28.1315L26.7584 30.6409C27.5838 31.0535 27.5838 32.2314 26.7584 32.644Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7595 12.5027C20.0564 13.2058 18.5743 12.8639 17.4493 11.7389C16.3243 10.6138 15.9823 9.13177 16.6855 8.42865C17.3886 7.72554 18.8706 8.06748 19.9957 9.19251C21.1207 10.3175 21.4626 11.7995 20.7595 12.5027Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3068_81531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVApps02);
export default __webpack_public_path__ + "static/media/vApps02.45e1444caa6c008d0c08588e01eefecc.svg";
export { ForwardRef as ReactComponent };